
class Clock {
  constructor() {
    // vars
    this.checkInterval = null;
    this.resetCheck = false;
    this.checkDate = null;

    this.clockTimer = null;
    this.quarters = 0;
    this.hours = 0;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.startCheck();
  }

  // --------------------------------------------------------------
  // Check
  // --------------------------------------------------------------

  startCheck() {
    this.checkInterval = setInterval(() => {
      this.timeCheck();
    }, 10000);
  }

  timeCheck() {
    this.checkDate = new Date();
    switch (this.checkDate.getMinutes()) {
      case 0:
        this.resetCheck = true;
        this.playSound(4, this.getHour());
        break;
      case 15:
        this.resetCheck = true;
        this.playSound(1, 0);
        break;
      case 30:
        this.resetCheck = true;
        this.playSound(2, 0);
        break;
      case 45:
        this.resetCheck = true;
        this.playSound(3, 0);
        break;
      default:
        this.resetCheck = false;
    }
    // try reset
    if (this.resetCheck) {
      clearInterval(this.checkInterval);
      // restart after ten minutes
      setTimeout(() => {
        this.startCheck();
      }, 1000 * 60 * 10);
    }
  }

  getHour() {
    const hour = this.checkDate.getHours() % 12;
    if (hour !== 0) {
      return hour;
    }
    return 12;
  }

  // --------------------------------------------------------------
  // Play
  // --------------------------------------------------------------

  playSound(quarters, hours) {
    this.quarters = quarters;
    this.hours = hours;
    clearInterval(this.clockTimer);
    this.tryQuarter();
    aPage.stats.trackEvent('Hodiny', `${quarters}-${hours}`);
  }

  tryQuarter() {
    if (this.quarters > 0) {
      this.quarters -= 1;
      if (aScene.sndManager.ambiActive) {
        aScene.sndManager.playSfx('hodiny-30');
      }
      this.clockTimer = setTimeout(() => {
        this.tryQuarter();
      }, 2200);
    } else {
      this.tryHour();
    }
  }

  tryHour() {
    if (this.hours > 0) {
      this.hours -= 1;
      if (aScene.sndManager.ambiActive) {
        aScene.sndManager.playSfx('hodiny-12');
      }
      this.clockTimer = setTimeout(() => {
        this.tryHour();
      }, 2200);
    }
  }
}

export default Clock;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/Clock.js